import { Injectable } from '@angular/core';
import { SecureSharePlugin } from 'cordova-plugin-secure-share/types/index';
import { Platform } from '@ionic/angular';
import { LogService } from './log.service';

declare const SecureShare: SecureSharePlugin;

@Injectable({
  providedIn: 'root'
})
export class SecureShareService {
  constructor(private platform: Platform, private log: LogService) {}

  save(map: Record<string, string>) {
    if (!this.platform.is('cordova')) { return; } // Don't save on simulation or pwa mode

    SecureShare.save(map).catch(error =>
      this.log.e(this, 'Error saving shared user data:', error)
    );
  }

  clear() {
    if (!this.platform.is('cordova')) { return; } // Don't save on simulation or pwa mode

    SecureShare.clear().catch(error =>
      this.log.e(this, 'Error clearing shared user data', error)
    );
  }
}
